const categoryItems = [
  {
    name: "Tech",
    iconName: "computer",
  },
  {
    name: "Travel",
    iconName: "map",
  },
  {
    name: "Food",
    iconName: "restaurant",
  },
  {
    name: "Entertainment",
    iconName: "live_tv",
  },
  {
    name: "Science",
    iconName: "poll",
  },
  {
    name: "Fitness",
    iconName: "fitness_center",
  },
  {
    name: "Education",
    iconName: "school",
  },
  {
    name: "Gaming",
    iconName: "videogame_asset",
  },
  {
    name: "Social",
    iconName: "comment",
  },
];

export default categoryItems;
